
define('template!ordersDetailOrderPhrasesItemView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="phrase-info">\n    <div class="phrase-code">' +
((__t = ( code )) == null ? '' : __t) +
'</div>\n    <div class="phrase-name">' +
((__t = ( internalName )) == null ? '' : __t) +
'</div>\n</div>\n<div class="phrase-actions">\n    <svg class="remove" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>\n</div>\n';

}
return __p
};});

